import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
//import FileBase64 from "react-file-base64";
//import Resizer from "react-image-file-resizer";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

import img from "assets/img/undraw_Male_avatar_g98d.png";
import imgLoader from "assets/img/progress.gif";
import LoadProfile from "components/services/LoadProfile";
import LoadGender from "components/services/LoadGender";
import { FlashOnOutlined } from "@material-ui/icons";

const useStyles = makeStyles(cardBodyStyle);

/*const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      "100%",
      "100%",
      "JPEG",
      18,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });*/

export default function MyAccount(props) {
  const classes = useStyles();
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [error, setError] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [loader, setLoader] = useState(true);

  const { urlServices, keyAplication, urlLocalMediaProfile } =
    useContext(UrlServicesContext);

  const [values, setValues] = useState({
    name: "",
    lastName: "",
    mail: "",
    gender_id: "",
    genderdata: [],
    gendername: "",
    profile_id: "",
    profiledata: [],
    profilename: "",
    password: "",
    picture: "",
    pictureBase64: "",
    errorName: false,
    errorLastName: false,
    errorGender: false,
    errorProfile: false,
  });

  let id = localStorage.getItem("id");

  useEffect(() => {
    axios
      .get(
        `${urlServices}routes_usersid.php?id=${id}&keyAplication=${keyAplication}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setValues({
          name: response.data.name,
          lastName: response.data.lastname,
          gender_id: response.data.gender_id,
          gendername: response.data.gendername,
          profile_id: response.data.profile_id,
          profilename: response.data.profilename,
          genderdata: {
            id: response.data.gender_id,
            name: response.data.gendername,
          },
          profiledata: {
            id: response.data.profile_id,
            name: response.data.profilename,
          },
          mail: response.data.email,
          picture:
            response.data.picture === null
              ? ""
              : urlLocalMediaProfile + response.data.picture,
          pictureBase64: "",
        });
        setLoader(false);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 200);
        } else {
          setError(true);
          setLoader(false);
        }
      });
  }, [urlServices, keyAplication, id, urlLocalMediaProfile]);

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
      errorLastName: false,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError("");

    if (values.name === "") {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setOpenAlert(true);
      setError("error");
      setoOpenBackdrop(false);
    } else if (values.lastName === "") {
      setValues({ ...values, errorLastName: true });
      setMensaje('El campo "Apellidos" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else {
      setoOpenBackdrop(true);

      let data = {
        id: id,
        name: values.name,
        lastName: values.lastName,
        email: values.mail,
        gender_id: values.gender_id,
        profile_id: values.profile_id,
        keyAplication: keyAplication,
      };

      if (values.pictureBase64 !== "") {
        data.picture = values.pictureBase64;
      }

      if (values.password !== "") {
        data.password = values.password;
      }

      axios
        .post(`${urlServices}routes_usersupdate.php`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(
          (response) => {
            if (response.data.code === 1) {
              setoOpenBackdrop(false);
              setError("success");
              setMensaje("Datos guardados con exito.");
              setOpenAlert(true);
            } else if (response.data.code === 10) {
              setoOpenBackdrop(false);
              setError("error");
              setMensaje("Error al modificar.");
              setOpenAlert(true);
            }
          },
          (error) => {
            console.log(error);
            setError("error");
            setMensaje("Error al registrar los datos.");
            setOpenAlert(true);
            setoOpenBackdrop(false);
          }
        );
    }
  };

  const changeProfile = (data) => {
    setValues({
      ...values,
      profile_id: data !== null ? data.id : "",
      profilename: data !== null ? data.name : "",
      profiledata: data !== null ? data : [],
      errorProfile: false,
    });
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  /*const uploadSingleFile = async (e) => {
    let image = "",
      outfile = "";

    if (e.length > 0 && e.length <= 1) {
      if (Number(e[0].file.size) > 500000) {
        // SI ES MAYOR A 500KB LE BAJAMOS EL PESO
        image = await resizeFile(e[0].file);
        // const newFile = dataURIToBlob(image);
        outfile = image;
      } else {
        outfile = e[0].base64;
      }
      setValues({ ...values, pictureBase64: outfile });
    }
  };*/

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Grid container spacing={1} className={classes.containerProfile}>
        {loader ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  src={imgLoader}
                  alt="loader"
                  style={{
                    width: 50,
                    margin: "100px 0",
                    objectFit: "contain",
                  }}
                />
              </center>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>Mi cuenta</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <center>
                  <img
                    alt="avatar"
                    src={img}
                    className={classes.imgUserProfile}
                  />
                  {/*<br></br>
                <label className={classes.buttonSubmit2}>
                  <FileBase64 multiple={true} onDone={uploadSingleFile} />
                  <i class="fa fa-cloud-upload"></i> Seleccionar foto
                </label>*/}
                </center>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="name"
                        value={values.name}
                        error={values.errorName}
                        onChange={handleChange("name")}
                        fullWidth
                        required
                        label="Nombre"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="lastname"
                        value={values.lastName}
                        error={values.errorLastName}
                        onChange={handleChange("lastName")}
                        fullWidth
                        required
                        label="Apellido"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadGender
                      refresh={changeGender}
                      value={values.genderdata}
                      error={values.errorGender}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadProfile
                      refresh={changeProfile}
                      value={values.profiledata}
                      error={values.errorProfile}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="mail"
                        value={values.mail}
                        error={values.errorMail}
                        onChange={handleChange("mail")}
                        fullWidth
                        required
                        label="Correo electrónico"
                        margin="dense"
                        autoComplete="off"
                        disabled
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="password"
                      value={values.password}
                      onChange={handleChange("password")}
                      label="Contraseña"
                      fullWidth
                      type="password"
                      helperText="Si desea cambiar la contraseña, ingrese la nueva en este campo."
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br></br>
                <center>
                  <Button
                    type="submit"
                    className={classes.buttonSubmit}
                    onClick={submitForm}
                  >
                    Guardar
                  </Button>
                </center>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={error === "error" ? "error" : "success"}
            elevation={6}
            variant="filled"
          >
            {mensaje}
          </Alert>
        </Slide>
      </Snackbar>
    </Fragment>
  );
}
